export const DetalleSistemaUnidadSectorGrupoFields = {
    NombreSistema: 'vchNombreSistema',
    CodSistema: 'sinCodSistema',
    NombreUnidadNegocio: 'vchNombreUnidadNegocio',
    CodUnidadNegocio: 'sinCodUnidadNegocio',
    NombreSectorComercial: 'vchNombreSectorComercial',
    CodSectorComercial: 'sinCodSectorComercial',
    NombreGrupo: 'vchNombreGrupo',
    IdGrupo: 'intIdGrupo',
    NombrePais: 'vchNombrePais',
    CodPais: 'sinCodPais'
} as const

export type DetalleSistemaUnidadSectorGrupoDTO = {
    [DetalleSistemaUnidadSectorGrupoFields.NombreSistema]: string
    [DetalleSistemaUnidadSectorGrupoFields.CodSistema]: number
    [DetalleSistemaUnidadSectorGrupoFields.NombreUnidadNegocio]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.CodUnidadNegocio]: number | null
    [DetalleSistemaUnidadSectorGrupoFields.NombreSectorComercial]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.CodSectorComercial]: number | null
    [DetalleSistemaUnidadSectorGrupoFields.NombreGrupo]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.IdGrupo]: number | null
    [DetalleSistemaUnidadSectorGrupoFields.NombrePais]: string | null
    [DetalleSistemaUnidadSectorGrupoFields.CodPais]: number | null
}
